import { render } from 'preact';
import { useState } from 'preact/hooks';
import { MwlIcons } from "./MwlIcons";
import { social_sharing_platforms } from '../settings';

const SocialSharingOptionsUI = ({ url, onClose }) => {
  return (
    <div className="mwl__pswp--sharing__options">
      <button 
        className="mwl__sharing__close" 
        aria-label="Close sharing options"
        onClick={onClose}
      >
        <MwlIcons icon={'close'} />
      </button>
      <ul>
        {social_sharing_platforms.map(({ label, path, enabled }) => (
          enabled && (
            <li key={label}>
              <a href={`${path}${url}`} target="_blank" rel="noopener noreferrer">
                {`Share on ${label}`}
              </a>
            </li>
          )
        ))}
      </ul>
    </div>
  );
};

const SocialSharingContainer = ({ url, containerParent }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    // Clean up the container after animation
    setTimeout(() => {
      const container = containerParent.querySelector('.mwl__sharing__container');
      if (container) {
        render(null, containerParent, container);
        container.remove();
      }
    }, 300); // Match transition time from CSS
  };

  if (!isOpen) {
    return null;
  }

  return <SocialSharingOptionsUI url={url} onClose={handleClose} />;
};

export const SocialSharingOptions = {
  render: (containerParent, url) => {
    const existingContainer = containerParent.querySelector('.mwl__sharing__container');
    
    if (existingContainer) {
      // Close existing
      render(null, containerParent, existingContainer);
      existingContainer.remove();
      return false; // Closed
    } else {
      // Open new
      const container = document.createElement('div');
      container.className = 'mwl__sharing__container';
      containerParent.appendChild(container);
      
      render(<SocialSharingContainer url={url} containerParent={containerParent} />, container);
      
      return true; // Opened
    }
  },
  
  close: (containerParent) => {
    const existingContainer = containerParent.querySelector('.mwl__sharing__container');
    if (existingContainer) {
      render(null, containerParent, existingContainer);
      existingContainer.remove();
    }
  }
};

